import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
} from "@angular/core";
import { CommonService } from "../../core/services/common.service";

@Component({
  selector: "app-common-search",
  templateUrl: "./common-search.component.html",
  styleUrls: ["./common-search.component.scss"],
})
export class CommonSearchComponent implements OnInit, OnDestroy {
  @Input() placeholder: string = "Search...";
  @Input() searchTerm: string = "";
  @Input() minSearchLength: number = 3;
  @Input() debounceTime: number = 1000;
  @Input() showIcon: boolean = true;
  @Input() iconPath: string = "assets/icons/ICON-search.svg";
  @Input() variant: "default" | "small" = "default";
  @Input() hintText: string = "";

  @Output() searchTermChange = new EventEmitter<string>();
  @Output() searchChange = new EventEmitter<string>();
  @Output() searchFocus = new EventEmitter<boolean>();

  private debouncedSearch: any;
  private lastValidSearchTerm: string = "";

  constructor(private commonService: CommonService) { }

  ngOnInit(): void {
    this.debouncedSearch = this.commonService.debounce(
      this.handleSearch.bind(this),
      this.debounceTime
    );

    // If there's a valid search term from URL, set it as the last valid search
    if (this.searchTerm && this.searchTerm.length >= this.minSearchLength) {
      this.lastValidSearchTerm = this.searchTerm;
    }
  }

  ngOnDestroy(): void {
    if (this.debouncedSearch) {
      this.debouncedSearch.cancel?.();
    }
  }

  onSearchInput(event: Event): void {
    const searchTerm = (event.target as HTMLInputElement).value?.trim();
    this.searchTermChange.emit(searchTerm);

    if (searchTerm.length === 0 && this.lastValidSearchTerm) {
      // Cancel any pending debounced search
      if (this.debouncedSearch && this.debouncedSearch.cancel) {
        this.debouncedSearch.cancel();
      }
      // Emit searchChange immediately (bypass debounce)
      this.searchChange.emit("");
      this.lastValidSearchTerm = "";
    } else {
      this.debouncedSearch(searchTerm);
    }
  }

  onSearchSubmit(): void {
    const searchTerm = this.searchTerm?.trim();
    if (searchTerm && searchTerm.length >= this.minSearchLength) {
      // Cancel any pending debounced search
      if (this.debouncedSearch && this.debouncedSearch.cancel) {
        this.debouncedSearch.cancel();
      }
      // Emit searchChange immediately (bypass debounce)
      this.searchChange.emit(searchTerm);
      this.lastValidSearchTerm = searchTerm;
    }
  }

  private handleSearch(searchTerm: string): void {
    if (searchTerm?.length < this.minSearchLength) return;
    this.searchChange.emit(searchTerm);
    this.lastValidSearchTerm = searchTerm;
  }

  clearSearch(): void {
    this.searchTermChange.emit("");
    // Only emit search change if we previously had a valid search term
    if (this.lastValidSearchTerm) {
      // Cancel any pending debounced search
      if (this.debouncedSearch && this.debouncedSearch.cancel) {
        this.debouncedSearch.cancel();
      }
      this.searchChange.emit("");
      this.lastValidSearchTerm = "";
    }
  }

  onSearchFocus(event: boolean): void {

    this.searchFocus.emit(event);
  }
}
